<div class="stream-page" *ngIf="!isLoading">
  <!-- UPCOMING EVENTS >> -->
  <div class="stream-page__container stream-page__container-top">
    <h1 class="upcoming-stream__page-title">{{pageTitle}}</h1>
    <div class="separator"></div>
    <div class="stream-page__upcoming-streams">
      <div class="stream-page__upcoming-stream" *ngFor="let stream of upcomingStreams">
        <a
          class="upcoming-stream__item left"
          [routerLink]="'/' + stream.channel.chefProfile.chefSlug + '/streams/' + stream.slug"
          (click)="sendGAEvent(stream.title)"
        >
          <div class="overlay"></div>
          <div class="upcoming-stream__thumbnail">
            <img
              class="upcoming-stream__author-img"
              data-testid="thumbnail"
              width="280"
              height="192"
              src="{{ stream.thumbnailUrl ? stream.thumbnailUrl : 'assets/ui/images/png/no-image.png' }}"
              alt="{{ stream.title }}"
            />
          </div>

          <!-- STREAM BADGE >> -->
          <ng-container *ngIf="stream.streamBadge">
            <div class="upcoming-stream__badge badge">
              <img
                height="50"
                width="107"
                [src]="stream.streamBadge"
                alt="badge"
              />
            </div>
          </ng-container>

          <ng-container *ngIf="!stream.streamBadge">
            <ng-container *ngIf="stream.isMushroomMonth">
              <div class="upcoming-stream__badge thumbnail-mushroom">
                <img src="assets/ui/images/png/mushroom-badge.png" alt="mushroom-month"/>
              </div>
            </ng-container>
            <ng-container *ngIf="stream.isEarthWeek">
              <div class="upcoming-stream__badge thumbnail-earth">
                <img
                  src="assets/ui/images/svg/earth-week.svg"
                  width="70"
                  height="52"
                  alt="earth-week"
                />
              </div>
            </ng-container>
            <ng-container *ngIf="stream.isFireChef">
              <div class="upcoming-stream__badge thumbnail-fire">
                <img
                  src="assets/ui/images/svg/fire-badge.svg"
                  width="198"
                  height="168"
                  alt="fire-badge"
                />
              </div>
            </ng-container>
          </ng-container>
          <!-- STREAM BADGE >> -->
        </a>

        <div class="upcoming-stream__item center">
          <div class="upcoming-stream__left">
            <div class="date-indicators-row">
              <div class="date-container">
                <div class="date-container__date">
                  {{ stream.scheduledVideo.date | timezone }}
                </div>
              </div>
              <div
                *ngIf="stream.paid && !stream.subscribed && !stream.subscribedToClub ||
                !stream.subscribedToClub && !!stream.requiredClubSubscriptionPlan"
                class="paid-indicator-container"
              >
                <img
                  class="paid-indicator"
                  [src]="'assets/ui/images/svg/paid-indicator.svg'"
                  alt="paid-indicator"
                  width="24"
                  height="24"
                >
              </div>
              <div class="upcoming-stream__access-indicator">
                <app-access-indicator
                  [isVideoPrivate]="stream.videoPrivate || stream.hidden"
                  [isPurchased]="stream.subscribed || stream.subscribedToClub"
                ></app-access-indicator>
              </div>
            </div>
            <a
              class="upcoming-stream__title"
              [routerLink]="'/' + stream.channel.chefProfile.chefSlug + '/streams/' + stream.slug"
              (click)="sendGAEvent(stream.title)"
            >{{ stream.title }}</a>
            <div class="upcoming-stream__author">
              <a
                *ngIf="!stream.collaborators?.length"
                [routerLink]="'/' + stream.channel.chefProfile.chefSlug"
              >
                <app-avatar
                  [url]="stream.channel.chefProfile.photo"
                  [size]="'scheduled'"
                  [name]="stream.channel.chefProfile.chefName"
                  [title]="stream.channel.name"
                  [avatarInputTextColor]="'green'"
                  [isLive]="stream.channel.chefProfile.isLive"
                  [isClub]="!!stream.requiredClubSubscriptionPlan"
                ></app-avatar>
              </a>
              <app-multiple-avatars
                *ngIf="stream.collaborators?.length"
                [chefs]="stream.collaborators"
              ></app-multiple-avatars>
            </div>
          </div>
          <div class="upcoming-stream__right">
            <div class="upcoming-stream__access-indicator">
              <app-access-indicator
                [isVideoPrivate]="stream.videoPrivate || stream.hidden"
                [isPurchased]="stream.subscribed || stream.subscribedToClub"
              ></app-access-indicator>
            </div>
            <app-learn-more-button
              *ngIf="stream.isPaymentRequire && !stream.requiredClubSubscriptionPlan ||
                !stream.subscribedToClub && stream.requiredClubSubscriptionPlan;
                else addToCalendarButton"
              (goToLink)="goToLink(stream)"
            ></app-learn-more-button>

            <ng-template #addToCalendarButton>
              <app-add-to-calendar-button
                *ngIf="stream.subscribed || stream.subscribedToClub; else saveMySpotButton"
                [stream]="stream"
              ></app-add-to-calendar-button>
            </ng-template>

            <ng-template #saveMySpotButton>
              <div class="upcoming-stream__action-button">
                <app-save-my-spot-button
                  [stream]="stream"
                ></app-save-my-spot-button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div *ngIf="!upcomingStreams?.length" class="empty-list">
        <div class="empty-list__title">No streams</div>
        <div class="empty-list__text">You haven’t had any upcoming events yet.</div>
      </div>
    </div>
  </div>
  <!-- << UPCOMING EVENTS  -->
</div>

<app-purchase-modal
  *ngIf="isPurchaseModalOpened"
  [stream]="purchaseStream"
  [isOpen]="isPurchaseModalOpened"
  (isPurchaseModalOpen)="setPurchaseModalStatus($event)"
></app-purchase-modal>
